import type { ReactNode } from 'react'

import cn from 'classnames'

import { configuration } from 'mmfintech-checkout-commons'
import { getPaymentMethodImageUrl } from 'mmfintech-commons'

import BankwireImage from '@assets/methods/bank-transfer.svg'
import CreditCardImage from '@assets/methods/credit-card.png'
import InstantBankTransferImage from '@assets/methods/instant-bank-transfer.svg'

const BANKWIRE_METHODS = ['EMONEY', 'BANKWIRE', 'LOCAL_BANKWIRE']
const INSTANT_TRANSFER_METHODS = [
  'COMMUNITY_INSTANT_BANK_TRANSFER',
  'DIRECT_INSTANT_BANK_TRANSFER',
  'INSTANT_BANK_TRANSFER'
]

interface MethodImageProps {
  method: string
  className?: string
  children?: ReactNode
}

export const PaymentMethodImage = ({ method, className, children }: MethodImageProps) => {
  if (BANKWIRE_METHODS.includes(method)) {
    return (
      <div className={cn('payment-method-image', className)}>
        <img src={BankwireImage} className='local' alt='Bank transfer' />
        {children}
      </div>
    )
  }

  if (INSTANT_TRANSFER_METHODS.includes(method)) {
    return (
      <div className={cn('payment-method-image', className)}>
        <img src={InstantBankTransferImage} className='local' alt='Instant bank transfer' />
        {children}
      </div>
    )
  }

  if (method === 'CREDIT_CARD') {
    return (
      <div className={cn('payment-method-image', className)}>
        <img src={CreditCardImage} className='local' alt='Credit card' />
        {children}
      </div>
    )
  }

  return (
    <div className={cn('payment-method-image', className)}>
      <img src={`${configuration.readBackendConfig()}${getPaymentMethodImageUrl(method)}`} alt={method} />
      {children}
    </div>
  )
}
